import Bugsnag from "@bugsnag/js";
import React, { type ComponentType } from "react";
import type { ReactNode } from "react";
import { bugsnagClient } from "./bugsnagClient";

const NoBoundary = ({ children }: { children: ReactNode }) => <>{children}</>;

export const ErrorBoundary = (
  bugsnagClient
    ? (Bugsnag.getPlugin("react")?.createErrorBoundary(React) ?? NoBoundary)
    : NoBoundary
) as ComponentType<{ children: ReactNode }>;
